module.exports = __webpack_public_path__ + "static/img/it1.3c7d28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it1.png
// module id = SkHb
// module chunks = 0